<template>
  <div style="text-align: center;">
    <div v-if="!hasError">
      <van-col :span="24" style="text-align: center;">
        票据管理
      </van-col>
    </div>
    <div v-else>
      <span style="font-size: 16px; font-weight: bold; color: #ff4949;">{{ errorMsg }}</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ElecnotesManage',
  data() {
    return {
      hasError: false,
      errorMsg: ''
    }
  },
  computed: {
    ...mapGetters(['token'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/elecnotes/manage.vue